import { Injectable } from '@angular/core';
import { UpdateControlPlatesDTO, UpdateUserInfoDTO, UserAccountClient, UserControlPlateClient, UserControlPlateDTO, UserInfoDTO } from '../models/models.swagger.generated';
import { forkJoin, map, Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserEditFormGroup } from '../user-management/user-edit-form/user-edit-form-type';

@Injectable({
  providedIn: 'root'
})
export class EditProfileService {

  constructor(
    private authService: AuthService,
    private userAccountClient: UserAccountClient,
    private userControlPlateClient: UserControlPlateClient) { }

  public resolve(): Observable<UserInfoDTO> {
    return this.authService.loadUserInfoDTO();
  }

  public save(form: UserEditFormGroup): Observable<UserInfoDTO> {
    if (form.valid) {
      return forkJoin({
        updatedUser: this.userAccountClient.updateUser(this.mapToUpdateUserInfoDTO(form)),
        userControlPlates: this.userControlPlateClient.updateUserControlPlates(new UpdateControlPlatesDTO({controlPlates: form.controls.controlPlates.value.map(p => new UserControlPlateDTO(p))}))
      }).pipe(map((result) => {
          this.authService.loadUserInfoDTO().subscribe();
          return result.updatedUser;
        }));
    } else {
      return of(null);
    }
  }

  private mapToUpdateUserInfoDTO(formData: UserEditFormGroup): UpdateUserInfoDTO {
    const dto = new UpdateUserInfoDTO();
    dto.firstname = formData.controls.firstname.getRawValue();
    dto.lastname = formData.controls.lastname.getRawValue();
    dto.userId = formData.controls.userId.getRawValue();
    dto.clientId = formData.controls.client.getRawValue()?.id;
    dto.email = formData.controls.email.getRawValue();
    dto.enabled = formData.controls.enabled.getRawValue();
    dto.language = formData.controls.language.getRawValue();
    dto.phoneNumber = formData.controls.phoneNumber.getRawValue();
    dto.roles = [formData.controls.role.getRawValue()];
    dto.fullAddress = formData.controls.fullAddress?.getRawValue();
    dto.addressCompletionId = formData.controls.addressCompletionId?.getRawValue();
    dto.addressAutocompleteSessionToken = formData.controls.addressAutocompleteSessionToken?.getRawValue();
    return dto;
  }
}
